import { FLAGS } from "@/define";

export const formatMoney = (amount: number): string => {
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(amount);
};

export const sortArrayOfObjects = <T>(
  data: T[],
  keyToSort: keyof T,
  direction: "ascending" | "descending" | "none"
) => {
  if (direction === "none") {
    return data;
  }
  const compare = (objectA: T, objectB: T) => {
    const valueA = objectA[keyToSort];
    const valueB = objectB[keyToSort];

    if (valueA === valueB) {
      return 0;
    }

    if (valueA > valueB) {
      return direction === "ascending" ? 1 : -1;
    } else {
      return direction === "ascending" ? -1 : 1;
    }
  };

  return data.slice().sort(compare);
};

export function copyStringWithoutReference(text: string) {
  return (" " + text).slice(1);
}

export function clearObjectValues<T>(objectToClear: T, cleanObject: T) {
  return Object.assign({}, objectToClear, cleanObject);
}

export function getBuyRouteName() {
  return FLAGS.ENABLE_ENHANCED_CART === "true" ? "buyEnhanceCartMain" : "buy";
}
